module.exports = __webpack_public_path__ + "img/hc_pro_seven_6.b2e1fc55.jpg";